import { Box, Skeleton } from '@mui/material';
import useBreakpoint from 'hooks/use-breakpoint';
import HeaderFallback from './components/header.fallback';

const TicketFallback = () => {
    const { lowerThan, biggerThan } = useBreakpoint();

    return (
        <HeaderFallback title="پشتیبانی" buttonLabels={['جستجو', 'تیکت جدید']}>
            <Box
                sx={{
                    display: 'flex',
                    width: '100%',
                    height: '100%',
                }}>
                {lowerThan('sm') ? null : (
                    <Box
                        sx={{
                            width: { xs: '100%', md: '30%' },
                            minWidth: '30%',
                            borderRadius: '8px',
                            mr: { xs: 0, md: 2 },
                            mb: { xs: 2, md: 0 },
                            height: { xs: '88%', md: '92%' },
                        }}>
                        <Skeleton variant="rectangular" height="100%" />
                    </Box>
                )}

                <Box
                    sx={{
                        borderRadius: '8px',
                        overflow: 'hidden',
                        width: '100%',
                        height: { xs: '88%', md: '92%' },
                    }}>
                    <Skeleton variant="rectangular" height="100%" />
                </Box>
            </Box>
        </HeaderFallback>
    );
};

export default TicketFallback;
